import React from 'react'

import { TopBar } from './TopBar'


// The signed-in shell: the teal top bar with the menu as tabs, content on cream below.
// (Named for the sidebar it replaced, so the router stays unchanged. SPEC.md, "Shell".)
export const createSidebarLayout = (menuEntries, avatarMenuEntries) =>
  ({ children }) => (
    <div className="dashboard-wrapper">
      <TopBar menuEntries={menuEntries} avatarMenuEntries={avatarMenuEntries} />
      <main className="dashboard-main">
        <div className="dashboard-content">
          {children}
        </div>
      </main>
    </div>
  )
